import { FC } from 'react';
import { useLanguage } from '@/contexts';
import { Select } from '..';

const LanguageSwitcher: FC = () => {
  const { i18n, changeLanguage } = useLanguage();
  const languages = [{ label: 'English', value: 'en' }, { label: 'Spanish', value: 'es' }];

  const handleChange = async (event: string) => {
    changeLanguage(event);
  };

  return (
    <Select
      label={''}
      options={languages}
      onChange={handleChange}
      value={i18n.language}
      className="px-2 py-1.5 sm:px-3 sm:py-2 md:px-4 md:py-3 text-xs sm:text-sm md:text-base"
    />
  );
};

export default LanguageSwitcher;
